import { Injectable } from '@angular/core';

import { DialogService } from '@mode/shared/ui';
import { EmailAdminDialogComponent, EmailAdminDialogData } from './email-admin-dialog.component';

@Injectable()
export class EmailAdminDialogService {
  readonly MODAL_ID = 'mode-email-admin-dialog';

  constructor(private _dialogService: DialogService) {}

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: TS7060
  open({ admins$, confirmAction }: EmailAdminDialogData) {
    const dialogExists = this._dialogService.getDialogById(this.MODAL_ID);
    if (!dialogExists) {
      const emailAdminDialogRef = this._dialogService.open<EmailAdminDialogComponent, EmailAdminDialogData>({
        component: EmailAdminDialogComponent,
        matDialogConfig: {
          id: this.MODAL_ID,
          data: { admins$ },
          minHeight: '256px',
        },
      });

      const confirmActionSubscription = emailAdminDialogRef.componentInstance.sendEmail.subscribe((formData) => {
        if (confirmAction) {
          confirmAction(formData);
        }
        confirmActionSubscription.unsubscribe();
      });

      return emailAdminDialogRef.afterClosed();
    }
  }
}
